import React, { useRef, useState } from 'react';
import { Box } from '@components/Box';
import {
  MainBackgroundImage,
  StyledMobileSection,
  StyledBox,
  NoFeeCashEverWrapper,
  BlogCenterTextPairing,
} from './RegistryCashFreeGiftingSection.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { defaultBase64Placeholder } from '@components/CloudImage';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';
import { useTranslation } from 'react-i18next';
import { Text } from '@components/typography';

interface RegistryCashFreeGiftingSectionProps {}

export const RegistryCashFreeGiftingSection: React.FC<RegistryCashFreeGiftingSectionProps> = () => {
  const CashFreeGiftingRef = useRef<HTMLDivElement>(null);
  let [isScrolledIntoView, setScrolledIntoView] = useState(false);

  const { t } = useTranslation('honeymoonRegistry');
  const publicCatalogSection = t('noFeeCashEverWrapper');

  return (
    <StyledMobileSection as="section" id="Honeymoon_Cash_Funds" marginTop={[10, 12]} ref={CashFreeGiftingRef}>
      <MainBackgroundImage backgroundImage={isScrolledIntoView ? 'honeymoon-fund/zero-fee-bg.jpg' : defaultBase64Placeholder}>
        <LazyLoadWrapper beforeLoad={() => setScrolledIntoView(true)}>
          <div />
        </LazyLoadWrapper>

        <NoFeeCashEverWrapper flexDirection="column" alignItems="center">
          <StyledBox alignItems="center">
            <BlogCenterTextPairing
              alignment="center"
              title={publicCatalogSection.title}
              titleVariant="hed72Hero"
              titleColor="neutra6"
              titleTagName="h2"
              body={publicCatalogSection.body}
              bodyVariant="dek24"
              bodyColor="neutra6"
              titleMaxWidth="710px"
              bodyTagName="p"
            />
          </StyledBox>

          <Box style={{ textAlign: 'center' }} marginTop={[8, 10]}>
            <Text variant="caption" tagName="p" color="neutra6" marginBottom={2}>
              {publicCatalogSection.conditionsAndFees}
            </Text>
            <GetStartedButton id="honeymoonCashFundsGetStartedBtn" page={'registry'} variant="primary">
              {t('getStarted')}
            </GetStartedButton>
          </Box>
        </NoFeeCashEverWrapper>
      </MainBackgroundImage>
    </StyledMobileSection>
  );
};
